// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.school-home-wrapper {
  height: 65vh;
  width: 100%;
}

.timeline-container {
  border-radius: 10px;
  background-color: #676666;
  height: 40%;
  width: 100%;
  padding: 16px 24px;
}

.at-a-glance-container {
  border-radius: 10px;
  background-color: #676666;
  color: white;
  margin-bottom: 32px;
  margin-top: 24px;
  min-height: 55%;
  padding: 16px 24px;
  width: 100%;
}

.sub-section-title {
  align-items: flex-end;
  color: white;
  display: flex;
  font-size: 19.2px;
  font-weight: 700;
  justify-content: space-between;
}

.sub-section-line {
  background-color: #EDEDED;
  color: #EDEDED;
  height: 1px;
  margin: 16px 0px;
}

.timeline-wrapper {
  display: flex;
  justify-content: space-around;
}

.timeline-item {
  color: #0669B3;
  height: 125px;
  width: 125px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  border-radius: 50%; /* may require vendor prefixes */
  background: white;
  font-size: 14px;
  padding: 1%;
}
.timeline-item .timeline-primary {
  align-items: center;
  display: flex;
  font-weight: 500;
  height: 54px;
  justify-content: center;
}
.timeline-item .timeline-secondary {
  font-size: 12px;
  margin-top: 8px;
  font-weight: 700;
  color: black;
}

.glance-manage-table {
  border-radius: 10px;
  background: #EDEDED;
  padding: 16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SchoolHome.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,YAAA;EACA,WAAA;AAUJ;;AAPA;ECLI,mBDMsB;EACtB,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAUJ;;AAPA;ECbI,mBDcsB;EACtB,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AAUJ;;AAPA;EACI,qBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;AAUJ;;AAPA;EACI,yBDrBI;ECsBJ,cDtBI;ECuBJ,WAAA;EACA,gBAAA;AAUJ;;AAPA;EACI,aAAA;EACA,6BAAA;AAUJ;;AAPA;EACI,cDjBS;ECkBT,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA,EAAA,gCAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;AAUJ;AATI;EACI,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;AAWR;AATI;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAWR;;AAPA;ECxEI,mBDyEsB;EACtB,mBD7DI;EC8DJ,aAAA;AAUJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.school-home-wrapper {\n    height: 65vh;\n    width: 100%;\n}\n\n.timeline-container {\n    @include borderRadius(10px);\n    background-color: #676666;\n    height: 40%;\n    width: 100%;\n    padding: 16px 24px;\n}\n\n.at-a-glance-container {\n    @include borderRadius(10px);\n    background-color: #676666;\n    color: white;\n    margin-bottom: 32px;\n    margin-top: 24px;\n    min-height: 55%;\n    padding: 16px 24px;\n    width: 100%;\n}\n\n.sub-section-title {\n    align-items: flex-end;\n    color: white;\n    display: flex;\n    font-size: 19.2px;\n    font-weight: 700;\n    justify-content: space-between;\n}\n\n.sub-section-line {\n    background-color: $white;\n    color: $white;\n    height: 1px;\n    margin: 16px 0px;\n}\n\n.timeline-wrapper {\n    display: flex;\n    justify-content: space-around;\n}\n\n.timeline-item {\n    color: $pearl-blue;\n    height: 125px;\n    width: 125px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    border-radius: 50%; /* may require vendor prefixes */\n    background: white;\n    font-size: 14px;\n    padding: 1%;\n    .timeline-primary {\n        align-items: center;\n        display: flex;\n        font-weight: 500;\n        height: 54px;\n        justify-content: center;\n    }\n    .timeline-secondary {\n        font-size: 12px;\n        margin-top: 8px;\n        font-weight: 700;\n        color: black;\n    }\n}\n\n.glance-manage-table {\n    @include borderRadius(10px);\n    background: $white;\n    padding: 16px;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
